import { render } from "./examPointHome.vue?vue&type=template&id=1bf6c79f&scoped=true"
import script from "./examPointHome.vue?vue&type=script&lang=js"
export * from "./examPointHome.vue?vue&type=script&lang=js"

import "./examPointHome.vue?vue&type=style&index=0&id=1bf6c79f&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf6c79f"]])

export default __exports__